import {
    ACTION_STATES,
    BasicAjaxAction,
    ComplexAction,
    DefaultAction,
    createHandler,
    createReducer,
} from "core/actions";
import AdvertisingService from "services/advertisingService";
import ContactService from "services/contactService";
import FilmReleaseAssociationTypeService from "services/filmReleaseAssociationTypeService";
import FilmService from "services/filmServices";
import envconfig from "../../../envconfig";


export const initState = {
    associationTypes: [],
    associationTypesStatus: [],
    attributeTypes: [],
    attributeTypesStatus: ACTION_STATES.NO_REQUEST,
    filmCompanies: [],
    filmCompaniesStatus: ACTION_STATES.NO_REQUEST,
    loadDataStatus: ACTION_STATES.NO_REQUEST,
    instructionPreset: [],
    instructionPresetStatus: ACTION_STATES.NO_REQUEST,
    reviewStatusTypes: [],
    filmRatingTypes: [],
    advertisementTypes: [],
    filmCodeTypes: [],
    users: [],
    tags: [],
    tagsLoadStatus: ACTION_STATES.NO_REQUEST,
    loadFilmStatus: ACTION_STATES.NO_REQUEST,
    filmTitles: [],
    loadContacts: ACTION_STATES.NO_REQUEST,
    contacts: [],
    filmReleases: [],
    films: [],
    filmStatus: ACTION_STATES.NO_REQUEST,
    contactRoles: [],
    globalSearchOpen:false
};

export class CLEAR_COMPANIES_TITLE extends DefaultAction {
    callRdx(state) {
        return Object.assign({}, state, { filmCompanies: [] });
    }
}
export class ON_LOAD_DATA_APP extends ComplexAction {
    successRdx(state, { payload }) {
        return Object.assign({}, state, {
            ...payload,
            loadDataStatus: ACTION_STATES.SUCCESS,
        });
    }
}
export class GLOBAL_SEARCH_CONFIG extends DefaultAction {
    callRdx(state, payload) {
        return Object.assign({}, state, {
            globalSearchConfig: {
                ...state.globalSearchConfig,
                ...payload
            }
        });
    }
}
export const actions = {
    GET_ASSOCIATION_TYPES: new BasicAjaxAction(
        "GET_ASSOCIATION_TYPES",
        "associationTypes",
        FilmReleaseAssociationTypeService.getAll
    ),
    GET_ATTRIBUTE_TYPES: new BasicAjaxAction(
        "GET_ATTRIBUTE_TYPES",
        "attributeTypes",
        AdvertisingService.getAttributeTypes
    ),
    GET_COMPANIES_TITLE: new BasicAjaxAction(
        "GET_COMPANIES_TITLE",
        "filmCompanies",
        AdvertisingService.getCompanyByTitle,
        { attribute: "filmCompaniesStatus" }
    ),
    GET_INSTRUCTION_PRESET: new BasicAjaxAction(
        "GET_INSTRUCTION_PRESET",
        "instructionPreset",
        AdvertisingService.getNomenclator,
        { attribute: "instructionPresetStatus" }
    ),
    GET_REVIEW_STATUS_TYPE: new BasicAjaxAction(
        "GET_REVIEW_STATUS_TYPE",
        "reviewStatusTypes",
        AdvertisingService.getNomenclator
    ),
    CLEAR_COMPANIES_TITLE: new CLEAR_COMPANIES_TITLE(),
    ON_LOAD_DATA_APP: new ON_LOAD_DATA_APP({ loadingAtr: "loadDataStatus" }),
    ON_LOAD_TAGS: new BasicAjaxAction("ON_LOAD_TAGS", "tags", AdvertisingService.getTags, {
        loadingAtr: "tagsLoadStatus",
    }),
    APP_GET_FILM_TITLE: new BasicAjaxAction("APP_GET_FILM_TITLE", "filmReleases", AdvertisingService.getFilmByTitle, {
        loadingAtr: "loadFilmStatus",
        debounce: envconfig.SEARCH_INPUT_DEBOUNCE_TIME
    }),
    APP_SEARCH_FILMS: new BasicAjaxAction("APP_SEARCH_FILMS", "films", FilmService.filter, {
        loadingAtr: "filmStatus",
        debounce: envconfig.SEARCH_INPUT_DEBOUNCE_TIME
    }),
    APP_GET_FILM_RATING_TYPE: new BasicAjaxAction(
        "APP_GET_FILM_RATING_TYPE",
        "filmRatingTypes",
        AdvertisingService.getNomenclator
    ),
    GET_CONTACTS: new BasicAjaxAction("GET_CONTACTS", "contacts", ContactService.getContactByName, {
        loadingAtr: "loadContacts",
        debounce: envconfig.SEARCH_INPUT_DEBOUNCE_TIME
    }),
    TOGGLE_GLOBAL_SEARCH_BTN: new DefaultAction("globalSearchOpen")

};

const handlers = createHandler(actions);

export const reducer = createReducer(initState, handlers);
export default actions;

export const filmTitlesSelector = (state) => state.globalApp.filmReleases;
export const advTypesSelector = (state) => state.globalApp.advertisementTypes;
export const TOGGLE_GLOBAL_SEARCH_OPEN = (state) => state.globalApp.globalSearchOpen;
export const usersSelector = (state) => state.globalApp.users;
export const reviewStatusTypesSelector = (state) => state.globalApp.reviewStatusTypes;
